export default "__VITE_ASSET__DU3Jh2or__"